import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Login from './module/auth/Login'
import p404 from './components/404'
import DashboardIndex from './module/dashboard/Index'

import customerRoutes from './module/customer/router'
import energeticsRoutes from './module/energetics/router'
import reportsRoutes from './module/reports/router'
import operationRoutes from './module/operation/router'
import marketPricesRoutes from './module/marketPrices/router'
import calculatorRoutes from './module/calculator/router'
import projectsRoutes from './module/projects/router'
import notificationsRoutes from './module/notifications/router'
import infoserviceRoutes from './module/infoservice/router'
import settingsRoutes from './module/settings/router'
import apiRoutes from './module/api/router'

//Others
import ProfileIndex from './module/profile/Index'
import ApiLogs from './module/settings/api/Log'

Vue.use(Router)

const defaultRoutes = [
  {
    path: '/',
    redirect: '/customer',
  },
  {
    path: '*',
    name: '404',
    component: p404,
    meta: {
      layout: 'minimal',
      auth: false,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      layout: 'minimal',
      auth: false,
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardIndex,
    meta: {
      auth: true,
    },
  },
]

let router = new Router({
  mode: 'history',
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    ...defaultRoutes,
    ...customerRoutes,
    ...energeticsRoutes,
    ...reportsRoutes,
    ...operationRoutes,
    ...marketPricesRoutes,
    ...calculatorRoutes,
    ...infoserviceRoutes,
    ...projectsRoutes,
    ...notificationsRoutes,
    ...settingsRoutes,
    ...apiRoutes,
    {
      path: '/interval-data',
      name: 'apiLogs',
      component: ApiLogs,
      meta: {
        auth: true,
        permission: 'view',
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: ProfileIndex,
      meta: {
        auth: true,
        permission: 'view',
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (store.getters['user/isLoggedIn']) {
    let permissions = store.getters['user/get'].allPermissions

    if (
      store.getters['user/isAdmin'] ||
      to.matched.some((record) => permissions.includes(record.meta.permission))
    ) {
      next()
    } else {
      next('/')
    }
  } else {
    next()
  }
})

export default router
